<template>
  <div class="course-statistics-page">
    <Watermark />

    <!-- 顶部校区选择：PC 为表单式下拉，移动端为底部弹层 -->
    <div :class="isPC ? 'header-section-pc' : 'header-section'">
      <template v-if="isPC">
        <div class="org-select-row-pc">
          
          <div ref="orgSelectWrapRef" class="org-select-wrap">
            <div
              class="org-select-trigger"
              :class="{ 'is-open': showOrgPcDropdown }"
              role="button"
              tabindex="0"
              @click.stop="toggleOrgPcDropdown"
              @keydown.enter.prevent="toggleOrgPcDropdown"
              @keydown.space.prevent="toggleOrgPcDropdown"
            >
              <span class="org-select-trigger-text">{{ selectedOrgName }}</span>
              <van-icon class="org-select-chevron" :name="showOrgPcDropdown ? 'arrow-up' : 'arrow-down'" />
            </div>
            <div
              v-show="showOrgPcDropdown"
              class="org-select-dropdown"
              @click.stop
            >
              <ul class="org-select-list">
                <li
                  v-for="opt in orgOptions"
                  :key="String(opt.value)"
                  class="org-select-item"
                  :class="{ active: String(opt.value) === String(selectedOrg) }"
                  @click="selectOrgPc(opt)"
                >
                  {{ opt.text }}
                </li>
              </ul>
            </div>
          </div>

        </div>

        <!-- PC 端日期筛选横条（仅 PC 模式显示，放在课时概览与类型统计之间） -->
    <div class="pc-date-filter-bar-standalone">
      <div class="pc-date-quick-tabs">
        <button
          v-for="key in PC_DATE_QUICK_KEYS"
          :key="key"
          type="button"
          class="pc-date-tab"
          :class="{ active: currentQuickType === key }"
          @click="handlePcQuickDate(key)"
        >
          {{ QUICK_TEXT[key] }}
        </button>
      </div>
      <div
        ref="pcDateRangeInputRef"
        class="pc-date-range-input"
        :class="{ 'is-custom': currentQuickType === QUICK_KEY.custom }"
        @click.stop="openPcRangePicker"
      >
        <van-icon name="calendar-o" class="pc-date-range-input__icon" />
        <div class="pc-date-range-input__inner">
          <span
            class="pc-date-range-input__part"
            :class="{ 'is-ph': !pcDisplayRange[0] }"
          >{{ pcDisplayRange[0] || '开始日期' }}</span>
          <span class="pc-date-range-input__sep">至</span>
          <span
            class="pc-date-range-input__part"
            :class="{ 'is-ph': !pcDisplayRange[1] }"
          >{{ pcDisplayRange[1] || '结束日期' }}</span>
        </div>
      </div>
            <van-button
              size="small"
              type="primary"
              :loading="refreshing"
              class="refresh-btn-pc"
              @click="handleRefresh"
            >
              <template #icon>
                <van-icon name="replay" :class="{ 'is-spinning': refreshing }" />
              </template>
              刷新
            </van-button>
    </div>
    
      </template>
      <template v-else>
        <div class="h5-header-row">
          <div class="org-select-card">
            <div class="org-select-btn" @click="showOrgPicker = true">
              {{ selectedOrgName }} <van-icon name="arrow-down" />
            </div>
          </div>
          <div class="h5-header-right">
            <van-button
              size="small"
              type="default"
              :loading="refreshing"
              class="refresh-btn-h5"
              @click="handleRefresh"
            >
              <template #icon>
                <van-icon name="replay" :class="{ 'is-spinning': refreshing }" />
              </template>
            </van-button>
            <van-button
              size="small"
              type="default"
              @click="showDateFilter = true"
              class="month-btn"
            >
              {{ currentDateRangeDisplay }} <van-icon name="arrow-down" />
            </van-button>
          </div>
        </div>
      </template>
    </div>

    <!-- 校区选择底部弹层（仅移动端） -->
    <van-action-sheet
      v-if="!isPC"
      v-model:show="showOrgPicker"
      :actions="orgOptions.map(item => ({ name: item.text, value: item.value }))"
      cancel-text="取消"
      @select="handleOrgSelect"
    />

    

    <!-- 课时概览 -->
    <div class="overview-section">
      <div class="overview-header">
        <div class="section-title">
          <span class="title-icon"></span>
          课时概览
        </div>
      </div>

      <div class="overview-cards-wrap">
      <div class="overview-cards">
        <div class="overview-card total" :style="{flex: isPC ? 1: 'none'}">
        <div class="card-content">
          <div class="card-value">{{ overviewData.lessonCount }}</div>
          <div class="card-label">上课次数</div>
        </div>
      </div>
      <div class="overview-card class-course" :style="{flex: isPC ? 1: 'none'}">
        <div class="card-content">
          <div class="card-value">{{ overviewData.attendanceCount }}</div>
          <div class="card-label">到课人次</div>
        </div>
      </div>
      <div class="overview-card one-to-one" :style="{flex: isPC ? 1: 'none'}">
        <div class="card-content">
          <div class="card-value">{{ overviewData.teacherClassHours }}</div>
          <div class="card-label">老师课时</div>
        </div>
      </div>
      <div class="overview-card attendance" :style="{flex: isPC ? 1: 'none'}">
        <div class="card-content">
          <div class="card-value">{{ overviewData.studentClassHours }}</div>
          <div class="card-label">学员课时</div>
        </div>
      </div>
      <div class="overview-card fee-consumed" :style="{flex: isPC ? 1: 'none'}" v-if="userType != '22'">
        <div class="card-content">
          <div class="card-value">{{ overviewData.totalConsumedAmount}}</div>
          <div class="card-label">学费消耗</div>
        </div>
      </div>
    </div>
    </div>
    
  </div>

  

    <!-- 类型统计 -->
    <div class="chart-section">
      <div class="section-title">
        <span class="title-icon type"></span>
        类型统计
      </div>
      <div class="dimension-toggle">
        <div
          v-for="option in dimensionOptions"
          :key="option.value"
          class="toggle-btn"
          :class="{ active: selectedDimension === option.value }"
          @click="handleDimensionChange(option.value)"
        >
          {{ option.label }}
        </div>
      </div>
      <div ref="typeChart" class="bar-chart"></div>
    </div>

    <!-- 学部统计 -->
    <div class="chart-section">
      <div class="section-title">
        <span class="title-icon division"></span>
        学部统计
      </div>
      <div class="dimension-toggle">
        <div
          v-for="option in divisionDimensionOptions"
          :key="option.value"
          class="toggle-btn"
          :class="{ active: selectedDivisionDimension === option.value }"
          @click="handleDivisionDimensionChange(option.value)"
        >
          {{ option.label }}
        </div>
      </div>
      <div ref="divisionChart" class="bar-chart"></div>
    </div>

    <!-- 年级出勤列表 -->
    <div class="list-section">
      <div class="section-title-row">
        <div class="section-title">
          <span class="title-icon grade-icon"></span>
          年级出勤列表
        </div>
      </div>
      <div class="list-content list-content--class-hours">
        <template v-if="gradeListData.length > 0">
          <div class="list-item header list-item--class-hours">
            <span class="col-grade-name">年级</span>
            <span class="col-hours-compact">上课课次</span>
            <span class="col-hours-compact">老师课时</span>
            <span class="col-hours-compact">学生课时</span>
            <span class="col-hours-compact" v-if="userType != '22'">学费消耗</span>
            <span class="col-hours-compact">出勤人次</span>
            <span class="col-hours-compact">应到人次</span>
            <span class="col-hours-compact">出勤率</span>
            <span class="col-hours-compact">班课出勤率</span>
            
          </div>
          <div
            v-for="(item, index) in gradeListData"
            :key="index"
            class="list-item list-item--class-hours"
            :class="{ odd: index % 2 === 1 }"
          >
            <span class="col-grade-name">{{ item.gradeName || item.grade || '未知' }}</span>
            <span class="col-hours-compact">{{ item.lessonCount || 0 }}</span>
            <span class="col-hours-compact">{{ item.teacherHours || 0 }}</span>
            <span class="col-hours-compact">{{ item.studentHours || 0 }}</span>
            <span class="col-hours-compact" v-if="userType != '22'">{{ item.studentAmount || 0 }}</span>
            <span class="col-hours-compact">{{ item.attendanceCount || 0 }}</span>
            <span class="col-hours-compact">{{ item.expectedAttendanceCount || 0 }}</span>
            <span class="col-hours-compact highlight">{{ formatAttendanceRate(item.attendanceRate) }}</span>
            <span class="col-hours-compact highlight">{{ formatAttendanceRate(item.classCourseAttendanceRate) }}</span>

            
          </div>
        </template>
        <EmptyData v-else tips="暂无年级出勤数据" />
      </div>
    </div>

    <!-- 老师课时列表 -->
    <div class="list-section">
      <div class="section-title-row">
        <div class="section-title">
          <span class="title-icon teacher-icon"></span>
          老师课时
        </div>
        <div class="section-actions">
          <div class="search-wrap">
            <van-icon class="search-icon" name="search" />
            <input
              v-model="teacherSearchKey"
              class="search-input"
              type="text"
              placeholder="搜索老师姓名"
            />
            <van-icon
              v-if="teacherSearchKey"
              class="clear-icon"
              name="clear"
              @click="teacherSearchKey = ''"
            />
          </div>
          <van-button
            v-if="source == 'PC' && userType != '22'"
            size="small"
            type="danger"
            plain
            class="export-btn"
            @click="handleExportTeacher"
          >
            导出
          </van-button>
          <div v-if="filteredTeacherList.length > 10" class="more-btn" @click="goToTeacherDetail">
            更多 <van-icon name="arrow" />
          </div>
          
        </div>
      </div>
      <div class="list-content">
        <template v-if="filteredTeacherList.length > 0">
          <div class="list-item header">
            <span class="col-rank">排名</span>
            <span class="col-name">老师</span>
            <span class="col-name">上课课次</span>
            <span class="col-name">老师课时</span>
            <span class="col-name">班课课时</span>
            <span class="col-name">1V1课时</span>
            <span class="col-name">1V2课时</span>
            <span class="col-name">学生课时</span>
            <span class="col-name" v-if="userType != '22'">学费消耗</span>
            <span class="col-name">出勤人次</span>
            <span class="col-name">应到人次</span>
            <span class="col-name">出勤率</span>
            <span class="col-name">班课出勤率</span>
          </div>
          <div
            v-for="(item, index) in filteredTeacherList.slice(0, 10)"
            :key="index"
            class="list-item"
            :class="{ odd: index % 2 === 1, top3: index < 3 }"
          >
          <span class="col-rank">
                <span class="rank-badge" :class="'rank-' + (index + 1)">{{ index + 1 }}</span>
            </span>
            <span class="col-name clickable" @click="handleTeacherClick(item)">{{ item.teacherName }}</span>
            <span class="col-name">{{ item.lessonCount || 0 }}</span>
            <span class="col-name">{{ item.teacherHours || 0 }}</span>
            <span class="col-name">{{ item.classCourseTeacherHours || 0 }}</span>
            <span class="col-name">{{ item.oneToOneTeacherHours || 0 }}</span>
            <span class="col-name">{{ item.oneToTwoTeacherHours || 0 }}</span>
            <span class="col-name highlight">{{ item.studentHours || 0 }}</span>
            <span class="col-name" v-if="userType != '22'">{{ item.studentAmount || 0 }}</span>
            <span class="col-name">{{ item.attendanceCount || 0 }}</span>
            <span class="col-name">{{ item.expectedAttendanceCount || 0 }}</span>
            <span class="col-name">{{ formatAttendanceRate(item.attendanceRate) }}</span>
            <span class="col-name">{{ formatAttendanceRate(item.classCourseAttendanceRate) }}</span>

          </div>
        </template>
        <EmptyData v-else tips="暂无老师课时数据" />
      </div>
    </div>

    <!-- 班主任课时列表 -->
    <div class="list-section">
      <div class="section-title-row">
        <div class="section-title">
          <span class="title-icon head-icon"></span>
          班主任课时
        </div>
        <div class="section-actions">
          <div class="search-wrap">
            <van-icon class="search-icon" name="search" />
            <input
              v-model="classTeacherSearchKey"
              class="search-input"
              type="text"
              placeholder="搜索班主任"
            />
            <van-icon
              v-if="classTeacherSearchKey"
              class="clear-icon"
              name="clear"
              @click="classTeacherSearchKey = ''"
            />
          </div>
        </div>
        <!-- v-if="classTeacherList.length > 10" -->
        <div v-if="filteredClassTeacherList.length > 4"  class="more-btn" @click="goToClassTeacherDetail">
          更多 <van-icon name="arrow" />
        </div>
      </div>
      <div class="list-content">
        <template v-if="filteredClassTeacherList.length > 0">
          <div class="list-item header">
            <span class="col-rank">排名</span>
            <span class="col-name">班主任</span>
            <span class="col-name">上课课次</span>
            <span class="col-name">老师课时</span>
            <span class="col-name">学生课时</span>
            <span class="col-name">班课课时</span>
            <span class="col-name">1V1课时</span>
            <span class="col-name">1V2课时</span>
            <span class="col-name" v-if="userType != '22'">学费消耗</span>
            <span class="col-name">出勤人次</span>
            <span class="col-name">应到人次</span>
            <span class="col-name">出勤率</span>
            <span class="col-name">班课出勤率</span>
            
          </div>
          <div
            v-for="(item, index) in filteredClassTeacherList.slice(0, 10)"
            :key="index"
            class="list-item"
            :class="{ odd: index % 2 === 1, top3: index < 3 }"
          >
          <span class="col-rank">
                <span class="rank-badge" :class="'rank-' + (index + 1)">{{ index + 1 }}</span>
            </span>
            <span class="col-name">{{ item.classTeacherName }}</span>
            <span class="col-name">{{ item.lessonCount || 0 }}</span>
            <span class="col-name">{{ item.teacherHours || 0 }}</span>
            <span class="col-name highlight">{{ item.studentHours || 0 }}</span>
            <span class="col-name">{{ item.classCourseTeacherHours || 0 }}</span>
            <span class="col-name">{{ item.oneToOneTeacherHours || 0 }}</span>
            <span class="col-name">{{ item.oneToTwoTeacherHours || 0 }}</span>
            <span class="col-name" v-if="userType != '22'">{{ item.studentAmount || 0 }}</span>
            <span class="col-name">{{ item.attendanceCount || 0 }}</span>
            <span class="col-name">{{ item.expectedAttendanceCount || 0 }}</span>

            <span class="col-name">{{ formatAttendanceRate(item.attendanceRate) }}</span>
            <span class="col-name">{{ formatAttendanceRate(item.classCourseAttendanceRate) }}</span>

            
          </div>
        </template>
        <EmptyData v-else tips="暂无班主任课时数据" />
      </div>
    </div>

    <!-- 班级课时列表 -->
    <div class="list-section">
      <div class="section-title-row">
        <div class="section-title">
          <span class="title-icon class-icon"></span>
          班级课时
        </div>
        <div class="section-actions">
          <van-button
            v-if="source == 'PC' && userType != '22'"
            size="small"
            type="danger"
            plain
            class="export-btn"
            @click="handleExportClass"
          >
            导出
          </van-button>
          <div v-if="classList.length > 10" class="more-btn" @click="goToClassDetail">
            更多 <van-icon name="arrow" />
          </div>
          
        </div>
      </div>
      <div class="list-content list-content--class-hours">
        <template v-if="classList.length > 0">
          <div class="list-item header list-item--class-hours">
            <span class="col-class-name">班级</span>
            <span class="col-class-code">班级编号</span>
            <span class="col-hours-compact">老师课时</span>
            <span class="col-hours-compact">学生课时</span>
            <span class="col-hours-compact" v-if="userType != '22'">学费消耗</span>
            <span class="col-hours-compact">出勤人次</span>
            <span class="col-hours-compact">应到人次</span>
            <span class="col-hours-compact">出勤率</span>
          </div>
          <div
            v-for="(item, index) in classList.slice(0, 10)"
            :key="index"
            class="list-item list-item--class-hours"
            :class="{ odd: index % 2 === 1 }"
          >
            <span class="col-class-name">{{ item.className }}</span>
            <span class="col-class-code">{{ item.classCode }}</span>
            <span class="col-hours-compact highlight">{{ item.teacherHours || 0 }}</span>
            <span class="col-hours-compact highlight">{{ item.studentHours || 0 }}</span>
            <span class="col-hours-compact" v-if="userType != '22'">{{ item.studentAmount || 0 }}</span>
            <span class="col-hours-compact">{{ item.attendanceCount || 0 }}</span>
            <span class="col-hours-compact">{{ item.expectedAttendanceCount || 0 }}</span>
            <span class="col-hours-compact">{{ formatAttendanceRate(item.attendanceRate) }}</span>
          </div>
        </template>
        <EmptyData v-else tips="暂无班级课时数据" />
      </div>
    </div>

    <!-- 个性化课时列表 -->
    <div class="list-section">
      <div class="section-title-row">
        <div class="section-title">
          <span class="title-icon personal-icon"></span>
          个性化课时
        </div>
        <div class="section-actions">
          <van-button
            v-if="source == 'PC' && userType != '22'"
            size="small"
            type="danger"
            plain
            class="export-btn"
            @click="handleExportPersonal"
          >
            导出
          </van-button>
          <div v-if="personalList.length > 10" class="more-btn" @click="goToPersonalDetail">
            更多 <van-icon name="arrow" />
          </div>
        </div>
      </div>
      <div class="list-content list-content--class-hours">
        <template v-if="personalList.length > 0">
          <div class="list-item header list-item--class-hours">
            <span class="col-class-name">班级名字</span>
            <span class="col-hours-compact">科目</span>
            <span class="col-hours-compact">老师</span>
            <span class="col-hours-compact">上课次数</span>
            <span class="col-hours-compact">到课人次</span>
            <span class="col-hours-compact">老师课时</span>
            <span class="col-hours-compact">学员课时</span>
            <span class="col-hours-compact" v-if="userType != '22'">学员消耗金额</span>
            
          </div>
          <div
            v-for="(item, index) in personalList.slice(0, 10)"
            :key="index"
            class="list-item list-item--class-hours"
            :class="{ odd: index % 2 === 1 }"
          >
            <span class="col-class-name">{{ item.className || '-' }}</span>
            <span class="col-hours-compact">{{ item.subject || '-' }}</span>
            <span class="col-hours-compact">{{ item.teacherName || '-' }}</span>
            <span class="col-hours-compact">{{ item.lessonCount || 0 }}</span>
            <span class="col-hours-compact">{{ item.attendanceCount || 0 }}</span>
            <span class="col-hours-compact highlight">{{ item.teacherClassHours || 0 }}</span>
            <span class="col-hours-compact highlight">{{ item.studentClassHours || 0 }}</span>
            <span class="col-hours-compact" v-if="userType != '22'">{{ formatAmount(item.studentAmount) }}</span>
            
          </div>
        </template>
        <EmptyData v-else tips="暂无个性化课时数据" />
      </div>
    </div>

    <!-- 日期筛选面板（移动端） -->
    <van-popup
      v-if="!isPC"
      v-model:show="showDateFilter"
      closeable
      position="bottom"
      round
    >
      <DateFilterPanel
        :config="{ quickType: currentQuickType }"
        @submit="handleDateFilterSubmit"
        @reset="handleDateFilterReset"
      />
    </van-popup>

    <PcDateRangePicker
      v-model:show="showPcRangePicker"
      :anchor-rect="pcRangeAnchorRect"
      :start="pcPickerStartStr"
      :end="pcPickerEndStr"
      :min-date="pcCalendarMinDate"
      :max-date="pcCalendarMaxDate"
      @confirm="onPcRangeConfirm"
    />
  </div>
</template>

<script setup>
import { ref, watch, onMounted, computed, onUnmounted, onBeforeUnmount, nextTick } from 'vue'
import * as echarts from 'echarts'
import Watermark from '@/components/Watermark.vue'
import dayjs from 'dayjs'
import DateFilterPanel from '@/components/dateFilterPanel/DateFilterPanel.vue'
import PcDateRangePicker from '@/components/dateFilterPanel/PcDateRangePicker.vue'
import EmptyData from '@/components/EmptyData.vue'
import {
  QUICK_KEY,
  QUICK_TEXT,
  getDateRangeByType,
  formatString,
} from '@/components/dateFilterPanel/utils.js'
import { postStatisticsCourseOverview, postDataPermissionsGetOrgs, postHourTypeStatistics, postHourPeriodStatistics, postHourClassStatistics, postHourTeacherRanking, postHourClassTeacherStatistics, postHourGradeStatistics, postHourPersonalStatistics } from '@/api/report'
import { querySyUserGetUserInfo } from '@/api/user'
// 校区选择
import { useRoute, useRouter } from "vue-router";

// 校区选择缓存 key
const ORG_CACHE_KEY = 'courseStatistics_selectedOrg'
const PC_CHART_MIN_WIDTH = 768

// PC端判断：屏幕宽度 >= 768px
// const isPC = () => typeof window !== 'undefined' && window.innerWidth >= PC_CHART_MIN_WIDTH
const isPC = ref(
  typeof window !== 'undefined' && window.innerWidth >= PC_CHART_MIN_WIDTH
)
// PC端柱宽固定值，移动端使用百分比
const PC_BAR_WIDTH = 40 // PC端固定40px
const MOBILE_BAR_WIDTH_PERCENT = '35%'
/** 柱子最大宽度（px），类目少时避免柱体被拉得过宽 */
const CHART_BAR_MAX_WIDTH = 80

/** 多校区柱状图：类目超过该数量时 X 轴标签倾斜，避免重叠 */
const CHART_X_AXIS_LABEL_ROTATE = 25
const CHART_X_AXIS_ROTATE_WHEN_COUNT_GT = 4

// 时间选择缓存 key
const DATE_CACHE_KEY = 'courseStatistics_dateFilter'

const selectedOrg = ref('all')
const orgOptions = ref([])

const isCustomermissions = ref(false)

const route = useRoute();
const router = useRouter();

const source = ref();

const userType = ref('')

// 保存当前校区选择
const saveOrgSelection = () => {
  sessionStorage.setItem(ORG_CACHE_KEY, selectedOrg.value)
}

// 保存时间筛选选择
const saveDateSelection = () => {
  const dateData = {
    quickType: currentQuickType.value,
    dateRange: currentDateRange.value
  }
  sessionStorage.setItem(DATE_CACHE_KEY, JSON.stringify(dateData))
}

const getUserInfo = async () => {
  try {

    const result = await querySyUserGetUserInfo({})

    if(result.code == '00') {

    } else {
      isCustomermissions.value = false
    }
    
  } catch (error) {
    
  }
}

// 跳转到班级课时详情
const goToClassDetail = () => {
  saveOrgSelection()
  saveDateSelection()
  const orgId = getOrgId()
  const startDate = currentDateRange.value[0]
  const endDate = currentDateRange.value[1]
  router.push({
    name: 'HoursDetail',
    query: {
      type: 'class',
      orgId,
      startDate,
      endDate,
      orgName: selectedOrgName.value
    }
  })
}

// 跳转到老师课时详情
const goToTeacherDetail = () => {
  saveOrgSelection()
  saveDateSelection()
  const orgId = getOrgId()
  const startDate = currentDateRange.value[0]
  const endDate = currentDateRange.value[1]
  router.push({
    name: 'HoursDetail',
    query: {
      type: 'teacher',
      orgId,
      startDate,
      endDate,
      orgName: selectedOrgName.value
    }
  })
}

// 跳转到班主任课时详情
const goToClassTeacherDetail = () => {
  saveOrgSelection()
  saveDateSelection()
  const orgId = getOrgId()
  const startDate = currentDateRange.value[0]
  const endDate = currentDateRange.value[1]
  router.push({
    name: 'HoursDetail',
    query: {
      type: 'classTeacher',
      orgId,
      startDate,
      endDate,
      orgName: selectedOrgName.value
    }
  })
}

// 点击老师姓名跳转到老师详情
const handleTeacherClick = (teacher) => {
  saveOrgSelection()
  saveDateSelection()
  const orgId = getOrgId()
  const startDate = currentDateRange.value[0]
  const endDate = currentDateRange.value[1]
  router.push({
    name: 'TeacherDetail',
    query: {
      teacherId: teacher.teacherId,
      teacherName: teacher.teacherName,
      orgId,
      startDate,
      endDate,
      orgName: selectedOrgName.value
    }
  })
}



// 加载校区列表
const loadOrgList = async () => {
  try {
    const res = await postDataPermissionsGetOrgs()
    if (res.code === '00' && res.data && res.data.length > 0) {
      const options = res.data.map(item => ({
        text: item.name || item.orgName,
        value: item.id
      }))
      orgOptions.value = [
        { text: '所有校区', value: 'all' },
        ...options
      ]
    }
    // 如果是从详情页返回，且 URL 没有传入 selctedOrgId，保持之前选择的校区
    const cachedOrg = sessionStorage.getItem(ORG_CACHE_KEY)
    if (cachedOrg && orgOptions.value.some(item => item.value == cachedOrg)) {
      selectedOrg.value = cachedOrg
    }
  } catch (error) {
    console.error('加载校区列表失败:', error)
    // 使用默认选项
    orgOptions.value = [
      { text: '所有校区', value: 'all' },
    ]
    // 如果是从详情页返回，保持之前选择的校区
    const cachedOrg = sessionStorage.getItem(ORG_CACHE_KEY)
    if (cachedOrg && orgOptions.value.some(item => item.value == cachedOrg)) {
      selectedOrg.value = cachedOrg
    }
  }
}

// 校区选择
const showOrgPicker = ref(false)
const orgSelectWrapRef = ref(null)
const showOrgPcDropdown = ref(false)

const toggleOrgPcDropdown = () => {
  showOrgPcDropdown.value = !showOrgPcDropdown.value
}

const selectOrgPc = (opt) => {
  selectedOrg.value = opt.value
  showOrgPcDropdown.value = false
  loadData()
}

const onDocumentClickCloseOrgPc = (e) => {
  if (!isPC.value || !showOrgPcDropdown.value) return
  const el = orgSelectWrapRef.value
  if (el && !el.contains(e.target)) {
    showOrgPcDropdown.value = false
  }
}

const selectedOrgName = computed(() => {
  const option = orgOptions.value.find(item => item.value == selectedOrg.value)
  return option?.text || '所有校区'
})

const handleOrgSelect = ({ value }) => {
  selectedOrg.value = value
  showOrgPicker.value = false
  loadData()
}

// 日期筛选
const showDateFilter = ref(false)
const refreshing = ref(false)
const currentQuickType = ref(QUICK_KEY.currentMonth)
const currentDateRange = ref('')

const PC_DATE_QUICK_KEYS = [
  QUICK_KEY.today,
  QUICK_KEY.currentWeek,
  QUICK_KEY.currentMonth,
  QUICK_KEY.currentYear,
  QUICK_KEY.prevWeek,
  QUICK_KEY.prevMonth,
  QUICK_KEY.fiscalYear,
]

const pcDateRangeInputRef = ref(null)
const showPcRangePicker = ref(false)
const pcRangeAnchorRect = ref(null)

// 从缓存恢复时间筛选选择
const restoreDateSelection = () => {
  const cachedDate = sessionStorage.getItem(DATE_CACHE_KEY)
  if (cachedDate) {
    try {
      const dateData = JSON.parse(cachedDate)
      currentQuickType.value = dateData.quickType || QUICK_KEY.currentMonth
      currentDateRange.value = dateData.dateRange || getDateRangeByType(dateData.quickType || QUICK_KEY.currentMonth)
    } catch (e) {
      currentDateRange.value = getDateRangeByType(currentQuickType.value)
    }
  } else {
    currentDateRange.value = getDateRangeByType(QUICK_KEY.currentMonth)
  }
}

const handleDateFilterSubmit = ({ quickType, dateRange }) => {
  currentQuickType.value = quickType
  currentDateRange.value = dateRange
  showDateFilter.value = false
  loadData()
}

const handleDateFilterReset = ({ quickType, dateRange }) => {
  currentQuickType.value = quickType
  currentDateRange.value = dateRange
  showDateFilter.value = false
  loadData()
}

// 初始化日期范围
restoreDateSelection()

// 日期筛选按钮展示文案：快捷类型显示中文，自定义显示时间段
const currentDateRangeDisplay = computed(() => {
  const type = currentQuickType.value
  const range = currentDateRange.value
  if (type === QUICK_KEY.custom && Array.isArray(range) && range.length >= 2) {
    return `${range[0]} ~ ${range[1]}`
  }
  return QUICK_TEXT[type] || '选择时间'
})

const pcDisplayRange = computed(() => {
  const r = currentDateRange.value
  if (Array.isArray(r) && r.length >= 2) return [r[0] || '', r[1] || '']
  return ['', '']
})

const pcPickerStartStr = computed(() => {
  const r = currentDateRange.value
  if (Array.isArray(r) && r[0]) return r[0]
  return dayjs().format(formatString)
})

const pcPickerEndStr = computed(() => {
  const r = currentDateRange.value
  if (Array.isArray(r) && r[1]) return r[1]
  return pcPickerStartStr.value
})

const pcCalendarMinDate = computed(() => dayjs().subtract(2, 'year').toDate())
const pcCalendarMaxDate = computed(() => dayjs().add(1, 'year').toDate())

// 课时概览数据
const overviewData = ref({
  attendanceCount: 0,
  lessonCount: 0,
  studentClassHours: 0,
  teacherClassHours: 0,
  totalConsumedAmount: 0
})

// 金额格式化（保留两位小数）
const formatAmount = (amount) => {
  const num = Number(amount) || 0
  return num.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
}

// 格式化出勤率
const formatAttendanceRate = (rate) => {
  if (rate === null || rate === undefined || rate === '') return '0%'
  const num = Number(rate)
  if (isNaN(num)) return '0%'
  return `${(num)}%`
}

// 类型统计数据
const typeData = ref([])

// 保存原始 API 数据，用于维度切换
let rawTypeStats = []
let rawPeriodStats = []
let rawOrgId = ''

// 维度切换
const baseDimensionOptions = [
  { label: '上课次数', value: 'lesson' },
  { label: '到课人次', value: 'attendance' },
  { label: '老师课时', value: 'teacherHours' },
  { label: '学生课时', value: 'studentHours' },
  { label: '学费消耗', value: 'studentAmount' }
]
const dimensionOptions = computed(() => {
  if (userType.value == '22') {
    return baseDimensionOptions.filter(item => item.value !== 'studentAmount')
  }
  return baseDimensionOptions
})
const selectedDimension = ref('studentHours')

// 根据维度获取班课数据字段
const getClassField = (dim) => {
  const map = {
    attendance: 'classCourseAttendanceCount',
    lesson: 'classCourseLessonCount',
    teacherHours: 'classCourseTeacherHours',
    studentHours: 'classCourseStudentHours',
    studentAmount: 'classCourseStudentAmount'
  }
  return map[dim] || 'classCourseStudentHours'
}

// 根据维度获取1V1数据字段
const getOneToOneField = (dim) => {
  const map = {
    attendance: 'oneToOneAttendanceCount',
    lesson: 'oneToOneLessonCount',
    teacherHours: 'oneToOneTeacherHours',
    studentHours: 'oneToOneStudentHours',
    studentAmount: 'oneToOneStudentAmount'
  }
  return map[dim] || 'oneToOneStudentHours'
}

// 根据维度获取1对多数据字段
const getOneToNField = (dim) => {
  const map = {
    attendance: 'oneToNAttendanceCount',
    lesson: 'oneToNLessonCount',
    teacherHours: 'oneToNTeacherHours',
    studentHours: 'oneToNStudentHours',
    studentAmount: 'oneToNStudentAmount'
  }
  return map[dim] || 'oneToNStudentHours'
}

// 维度切换处理
const handleDimensionChange = (dim) => {
  selectedDimension.value = dim
  // 根据选择的维度重新计算 typeData
  if (rawTypeStats.length === 0) return

  if (isAllOrg.value) {
    // 所有校区 - 按校区维度的堆叠图
    const classField = getClassField(dim)
    const oneToOneField = getOneToOneField(dim)
    const oneToNField = dim === 'oneToN' ? 'oneToNStudentHours' : getOneToNField(dim)
    typeData.value = rawTypeStats.map(item => ({
      orgName: item.orgName || '未知校区',
      classHours: item[classField] || 0,
      oneToOneHours: item[oneToOneField] || 0,
      oneToNHours: item[oneToNField] || 0
    }))
  } else {
    // 单个校区 - 按类型/学段的柱状图
    const currentOrgTypeStats = rawTypeStats.filter(item => String(item.orgId) === String(rawOrgId))
    const classField = getClassField(dim)
    const oneToOneField = getOneToOneField(dim)
    const oneToNField = dim === 'oneToN' ? 'oneToNStudentHours' : getOneToNField(dim)
    const classHours = currentOrgTypeStats.reduce((sum, item) => sum + (item[classField] || 0), 0)
    const oneToOneHoursVal = currentOrgTypeStats.reduce((sum, item) => sum + (item[oneToOneField] || 0), 0)
    const oneToNHoursVal = currentOrgTypeStats.reduce((sum, item) => sum + (item[oneToNField] || 0), 0)
    typeData.value = [
      { typeName: '班课', hours: Math.round(classHours) },
      { typeName: '1V1', hours: Math.round(oneToOneHoursVal) },
      { typeName: '1对多', hours: Math.round(oneToNHoursVal) }
    ]
  }
  renderCharts()
}

// 学部维度切换
const baseDivisionDimensionOptions = [
  { label: '上课次数', value: 'lessonCount' },
  { label: '到课人次', value: 'attendanceCount' },
  { label: '老师课时', value: 'teacherHours' },
  { label: '学生课时', value: 'studentHours' },
  { label: '学费消耗', value: 'studentAmount' }
]
const divisionDimensionOptions = computed(() => {
  if (userType.value == '22') {
    return baseDivisionDimensionOptions.filter(item => item.value !== 'studentAmount')
  }
  return baseDivisionDimensionOptions
})
const selectedDivisionDimension = ref('studentHours')

// 学部分统计数据
const divisionData = ref([])

// 年级维度选项
const baseGradeDimensionOptions = [
  { label: '上课次数', value: 'lessonCount' },
  { label: '到课人次', value: 'attendanceCount' },
  { label: '老师课时', value: 'teacherHours' },
  { label: '学生课时', value: 'studentHours' },
  { label: '学费消耗', value: 'studentAmount' }
]
const gradeDimensionOptions = computed(() => {
  if (userType.value == '22') {
    return baseGradeDimensionOptions.filter(item => item.value !== 'studentAmount')
  }
  return baseGradeDimensionOptions
})
const selectedGradeDimension = ref('attendanceCount')

// 年级统计数据
const gradeData = ref([])

// 年级出勤列表数据（扁平化的年级数据）
const gradeListData = ref([])

// 保存原始年级统计数据
let rawGradeStats = []

// 学部维度切换处理
const handleDivisionDimensionChange = (dim) => {
  selectedDivisionDimension.value = dim
  if (rawPeriodStats.length === 0) return

  if (isAllOrg.value) {
    // 所有校区 - 按校区分组汇总各学段课时
    const orgPeriodMap = {}
    rawPeriodStats.forEach(item => {
      if (!orgPeriodMap[item.orgId]) {
        orgPeriodMap[item.orgId] = {
          orgName: item.orgName || '未知校区',
          primaryHours: 0,
          juniorHours: 0,
          seniorHours: 0
        }
      }
      // 根据维度获取对应数据
      if (dim === 'attendanceCount') {
        if (item.period === '1') {
          orgPeriodMap[item.orgId].primaryHours += item.attendanceCount || 0
        } else if (item.period === '2') {
          orgPeriodMap[item.orgId].juniorHours += item.attendanceCount || 0
        } else if (item.period === '3') {
          orgPeriodMap[item.orgId].seniorHours += item.attendanceCount || 0
        }
      } else if (dim === 'lessonCount') {
        if (item.period === '1') {
          orgPeriodMap[item.orgId].primaryHours += item.lessonCount || 0
        } else if (item.period === '2') {
          orgPeriodMap[item.orgId].juniorHours += item.lessonCount || 0
        } else if (item.period === '3') {
          orgPeriodMap[item.orgId].seniorHours += item.lessonCount || 0
        }
      } else if (dim === 'teacherHours') {
        if (item.period === '1') {
          orgPeriodMap[item.orgId].primaryHours += item.teacherHours || 0
        } else if (item.period === '2') {
          orgPeriodMap[item.orgId].juniorHours += item.teacherHours || 0
        } else if (item.period === '3') {
          orgPeriodMap[item.orgId].seniorHours += item.teacherHours || 0
        }
      } else if (dim === 'studentAmount') {
        if (item.period === '1') {
          orgPeriodMap[item.orgId].primaryHours += item.studentAmount || 0
        } else if (item.period === '2') {
          orgPeriodMap[item.orgId].juniorHours += item.studentAmount || 0
        } else if (item.period === '3') {
          orgPeriodMap[item.orgId].seniorHours += item.studentAmount || 0
        }
      } else {
        // studentHours
        if (item.period === '1') {
          orgPeriodMap[item.orgId].primaryHours += item.studentHours || 0
        } else if (item.period === '2') {
          orgPeriodMap[item.orgId].juniorHours += item.studentHours || 0
        } else if (item.period === '3') {
          orgPeriodMap[item.orgId].seniorHours += item.studentHours || 0
        }
      }
    })
    divisionData.value = Object.values(orgPeriodMap)
  } else {
    // 单个校区 - 按学段维度
    const currentOrgPeriodStats = rawPeriodStats.filter(item => String(item.orgId) === String(rawOrgId))
    let primaryHours = 0
    let juniorHours = 0
    let seniorHours = 0
    currentOrgPeriodStats.forEach(item => {
      if (dim === 'attendanceCount') {
        if (item.period === '1') primaryHours += item.attendanceCount || 0
        else if (item.period === '2') juniorHours += item.attendanceCount || 0
        else if (item.period === '3') seniorHours += item.attendanceCount || 0
      } else if (dim === 'lessonCount') {
        if (item.period === '1') primaryHours += item.lessonCount || 0
        else if (item.period === '2') juniorHours += item.lessonCount || 0
        else if (item.period === '3') seniorHours += item.lessonCount || 0
      } else if (dim === 'teacherHours') {
        if (item.period === '1') primaryHours += item.teacherHours || 0
        else if (item.period === '2') juniorHours += item.teacherHours || 0
        else if (item.period === '3') seniorHours += item.teacherHours || 0
      } else if (dim === 'studentAmount') {
        if (item.period === '1') primaryHours += item.studentAmount || 0
        else if (item.period === '2') juniorHours += item.studentAmount || 0
        else if (item.period === '3') seniorHours += item.studentAmount || 0
      } else {
        // studentHours
        if (item.period === '1') primaryHours += item.studentHours || 0
        else if (item.period === '2') juniorHours += item.studentHours || 0
        else if (item.period === '3') seniorHours += item.studentHours || 0
      }
    })
    divisionData.value = [{
      orgName: '学部分布',
      primaryHours: Math.round(primaryHours),
      juniorHours: Math.round(juniorHours),
      seniorHours: Math.round(seniorHours)
    }]
  }
  renderDivisionChart()
}

// 年级维度切换处理
const handleGradeDimensionChange = (dim) => {
  selectedGradeDimension.value = dim
  // 重置选中状态
  if (gradeData.value && gradeData.value.length > 0) {
    const allGradeNames = []
    gradeData.value.forEach((org) => {
      const grades = org.grades || []
      grades.forEach((g) => {
        const key = g.gradeName || g.grade || '未知'
        if (!allGradeNames.includes(key)) allGradeNames.push(key)
      })
    })
    gradeLegendSelected.value = {}
    allGradeNames.forEach((name) => {
      gradeLegendSelected.value[name] = true
    })
  }
  renderGradeChart()
}

// 班级课时列表数据
const classList = ref([])

// 个性化课时列表数据
const personalList = ref([])

// 老师课时列表数据
const teacherList = ref([])

// 班主任课时列表数据
const classTeacherList = ref([])

// 老师搜索关键字
const teacherSearchKey = ref('')

// 班主任搜索关键字
const classTeacherSearchKey = ref('')

// 过滤后的老师列表
const filteredTeacherList = computed(() => {
  if (!teacherSearchKey.value) {
    return teacherList.value
  }
  const key = teacherSearchKey.value.toLowerCase()
  return teacherList.value.filter(item =>
    (item.teacherName || '').toLowerCase().includes(key)
  )
})

// 过滤后的班主任列表
const filteredClassTeacherList = computed(() => {
  if (!classTeacherSearchKey.value) {
    return classTeacherList.value
  }
  const key = classTeacherSearchKey.value.toLowerCase()
  return classTeacherList.value.filter(item =>
    (item.classTeacherName || '').toLowerCase().includes(key)
  )
})

// 图表DOM引用
const typeChart = ref(null)
const divisionChart = ref(null)
let typeChartInstance = null
let divisionChartInstance = null
let chartResizeObserver = null

/** ECharts 画布尺寸来自初始化时的容器；容器变化后必须 resize，仅靠 setOption 不会更新画布宽高 */
const flushChartResize = () => {
  nextTick(() => {
    typeChartInstance?.resize()
    divisionChartInstance?.resize()
  })
}

// 判断是否选择了所有校区
const isAllOrg = computed(() => selectedOrg.value === 'all')

// 获取当前柱宽（PC端固定px，移动端百分比）
const getBarWidth = () => isPC.value ? PC_BAR_WIDTH : MOBILE_BAR_WIDTH_PERCENT

// 类型图例选中状态（与 ECharts legend 同步，用于柱顶总和随可见系列变化）
const typeLegendSelected = ref({ 班课: true, '1V1': true, '1对多': true })

const getTypeVisibleTotal = (row, sel) => {
  const c = Number(row.classHours) || 0
  const o = Number(row.oneToOneHours) || 0
  const n = Number(row.oneToNHours) || 0
  let sum = 0
  if (sel['班课'] !== false) sum += c
  if (sel['1V1'] !== false) sum += o
  if (sel['1对多'] !== false) sum += n
  return sum
}

/** 当前柱最上层可见分段（班课在下 → 1V1 → 1对多在上） */
const getTypeTopSegment = (row, sel) => {
  const c = Number(row.classHours) || 0
  const o = Number(row.oneToOneHours) || 0
  const n = Number(row.oneToNHours) || 0
  const showN = sel['1对多'] !== false && n > 0
  const showO = sel['1V1'] !== false && o > 0
  const showC = sel['班课'] !== false && c > 0
  if (showN) return '1对多'
  if (showO) return '1V1'
  if (showC) return '班课'
  return null
}

/** 所有校区-类型堆叠：柱顶显示「当前可见系列」之和，标签画在最顶可见层 */
const typeAllOrgTotalLabelFormatter = (layer) => (params) => {
  const row = typeData.value[params.dataIndex]
  if (!row) return ''
  const sel = typeLegendSelected.value
  const sum = getTypeVisibleTotal(row, sel)
  if (!sum) return ''
  const top = getTypeTopSegment(row, sel)
  if (layer === 'class') return top === '班课' ? String(sum) : ''
  if (layer === 'oneToOne') return top === '1V1' ? String(sum) : ''
  if (layer === 'oneToN') return top === '1对多' ? String(sum) : ''
  return ''
}

const onTypeLegendSelectChanged = (e) => {
  if (!isAllOrg.value || !typeChartInstance) return
  typeLegendSelected.value = { ...typeLegendSelected.value, ...(e.selected || {}) }
  typeChartInstance.setOption(
    {
      series: [
        { label: { formatter: typeAllOrgTotalLabelFormatter('class') } },
        { label: { formatter: typeAllOrgTotalLabelFormatter('oneToOne') } },
        { label: { formatter: typeAllOrgTotalLabelFormatter('oneToN') } }
      ]
    },
    false
  )
}

// 学部图例选中状态（与 ECharts legend 同步）
const divisionLegendSelected = ref({ 小学: true, 初中: true, 高中: true })

const getDivisionVisibleTotal = (row, sel) => {
  const p = Number(row.primaryHours) || 0
  const j = Number(row.juniorHours) || 0
  const s = Number(row.seniorHours) || 0
  let sum = 0
  if (sel['小学'] !== false) sum += p
  if (sel['初中'] !== false) sum += j
  if (sel['高中'] !== false) sum += s
  return sum
}

/** 堆叠顺序：小学(下) → 初中 → 高中(上)，取最上层可见且数值>0 的一段 */
const getDivisionTopSegment = (row, sel) => {
  const p = Number(row.primaryHours) || 0
  const j = Number(row.juniorHours) || 0
  const s = Number(row.seniorHours) || 0
  const showS = sel['高中'] !== false && s > 0
  const showJ = sel['初中'] !== false && j > 0
  const showP = sel['小学'] !== false && p > 0
  if (showS) return 'senior'
  if (showJ) return 'junior'
  if (showP) return 'primary'
  return null
}

/** 所有校区-学部堆叠：柱顶为可见系列之和，标签画在最顶可见层 */
const divisionAllOrgTotalLabelFormatter = (layer) => (params) => {
  const row = divisionData.value[params.dataIndex]
  if (!row) return ''
  const sel = divisionLegendSelected.value
  const sum = getDivisionVisibleTotal(row, sel)
  if (!sum) return ''
  const top = getDivisionTopSegment(row, sel)
  if (layer === 'senior') return top === 'senior' ? String(sum) : ''
  if (layer === 'junior') return top === 'junior' ? String(sum) : ''
  if (layer === 'primary') return top === 'primary' ? String(sum) : ''
  return ''
}

const onDivisionLegendSelectChanged = (e) => {
  if (!isAllOrg.value || !divisionChartInstance) return
  divisionLegendSelected.value = { ...divisionLegendSelected.value, ...(e.selected || {}) }
  divisionChartInstance.setOption(
    {
      series: [
        { label: { formatter: divisionAllOrgTotalLabelFormatter('primary') } },
        { label: { formatter: divisionAllOrgTotalLabelFormatter('junior') } },
        { label: { formatter: divisionAllOrgTotalLabelFormatter('senior') } }
      ]
    },
    false
  )
}

// 年级图例选中状态
const gradeLegendSelected = ref({})

const getGradeVisibleTotal = (row, sel) => {
  const grades = row.grades || []
  let sum = 0
  grades.forEach((g) => {
    const key = g.gradeName || g.grade || '未知'
    if (sel[key] !== false) {
      sum += Number(g[selectedGradeDimension.value]) || 0
    }
  })
  return sum
}

const getGradeTopSegment = (row, sel) => {
  const grades = row.grades || []
  for (let i = grades.length - 1; i >= 0; i--) {
    const g = grades[i]
    const key = g.gradeName || g.grade || '未知'
    const val = Number(g[selectedGradeDimension.value]) || 0
    if (sel[key] !== false && val > 0) return key
  }
  return null
}

const gradeAllOrgTotalLabelFormatter = (gradeName) => (params) => {
  const row = gradeData.value[params.dataIndex]
  if (!row) return ''
  const sel = gradeLegendSelected.value
  const sum = getGradeVisibleTotal(row, sel)
  if (!sum) return ''
  const top = getGradeTopSegment(row, sel)
  return top === gradeName ? String(sum) : ''
}

const onGradeLegendSelectChanged = (e) => {
  if (!isAllOrg.value || !gradeChartInstance) return
  gradeLegendSelected.value = { ...gradeLegendSelected.value, ...(e.selected || {}) }
  const sel = gradeLegendSelected.value
  const labels = Object.keys(sel)
  gradeChartInstance.setOption(
    {
      series: labels.map((name) => ({
        label: { formatter: gradeAllOrgTotalLabelFormatter(name) }
      }))
    },
    false
  )
}

const chartTooltipTextStyle = { color: '#333', fontSize: 12, align: 'left' }
const chartTooltipExtraCssText = 'text-align:left;'

const axisTooltipFormatterLeft = (params) => {
  if (!Array.isArray(params) || !params.length) return ''
  const title = params[0].axisValueLabel ?? params[0].name ?? ''
  const rows = params.map(
    (p) =>
      `<div style="text-align:left;line-height:22px">${p.marker}<span style="margin:0 6px 0 4px">${p.seriesName}</span><span>${p.value}</span></div>`
  )
  return `<div style="text-align:left"><div style="font-weight:600;margin-bottom:6px">${title}</div>${rows.join('')}</div>`
}

const itemTooltipFormatterLeft = (params) => {
  const p = Array.isArray(params) ? params[0] : params
  if (!p) return ''
  return `<div style="text-align:left;line-height:22px">${p.marker}<span style="margin:0 6px 0 4px">${p.seriesName}</span><span>${p.value}</span></div>`
}

// 渲染类型统计图表
const renderTypeChart = () => {
  if (!typeChart.value) return

  if (!typeChartInstance) {
    typeChartInstance = echarts.init(typeChart.value)
    typeChartInstance.on('legendselectchanged', onTypeLegendSelectChanged)
  }

  let option = {}

  if (isAllOrg.value) {
    // 堆叠图 - 按校区维度
    const typeXCount = typeData.value.length
    const typeXRotate =
      typeXCount > CHART_X_AXIS_ROTATE_WHEN_COUNT_GT ? CHART_X_AXIS_LABEL_ROTATE : 0
    const typeGridBottom = typeXRotate ? '16%' : '14%'
    option = {
      tooltip: {
        trigger: 'axis',
        renderMode: 'html',
        axisPointer: { type: 'shadow' },
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderColor: '#e8e8e8',
        borderWidth: 1,
        textStyle: chartTooltipTextStyle,
        extraCssText: chartTooltipExtraCssText,
        formatter: axisTooltipFormatterLeft
      },
      legend: {
        data: ['班课', '1V1', '1对多'],
        selected: { ...typeLegendSelected.value },
        bottom: 5,
        itemWidth: 14,
        itemHeight: 14,
        textStyle: { fontSize: 12, color: '#666' },
        itemGap: 20
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: typeGridBottom,
        top: '8%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: typeData.value.map(item => item.orgName),
        axisLabel: {
          fontSize: 12,
          color: '#666',
          rotate: typeXRotate,
          interval: 0,
          align: typeXRotate ? 'right' : 'center'
        },
        axisLine: { lineStyle: { color: '#e8e8e8' } },
        axisTick: { show: false }
      },
      yAxis: {
        type: 'value',
        name: '',
        nameTextStyle: { color: '#999', fontSize: 11 },
        axisLabel: { fontSize: 11, color: '#999' },
        axisLine: { show: false },
        splitLine: { lineStyle: { color: '#f0f0f0', type: 'dashed' } }
      },
      series: [
        {
          name: '班课',
          type: 'bar',
          stack: 'total',
          barWidth: getBarWidth(),
          barMaxWidth: CHART_BAR_MAX_WIDTH,
          data: typeData.value.map(item => item.classHours),
          itemStyle: { color: '#3478f6', borderRadius: [0, 0, 0, 0] },
          label: {
            show: true,
            position: 'top',
            formatter: typeAllOrgTotalLabelFormatter('class'),
            fontSize: 14,
            fontWeight: 600,
            color: '#333'
          }
        },
        {
          name: '1V1',
          type: 'bar',
          stack: 'total',
          barWidth: getBarWidth(),
          barMaxWidth: CHART_BAR_MAX_WIDTH,
          data: typeData.value.map(item => item.oneToOneHours),
          itemStyle: { color: '#ff9f43', borderRadius: [0, 0, 0, 0] },
          label: {
            show: true,
            position: 'top',
            formatter: typeAllOrgTotalLabelFormatter('oneToOne'),
            fontSize: 14,
            fontWeight: 600,
            color: '#333'
          }
        },
        {
          name: '1对多',
          type: 'bar',
          stack: 'total',
          barWidth: getBarWidth(),
          barMaxWidth: CHART_BAR_MAX_WIDTH,
          data: typeData.value.map(item => item.oneToNHours),
          itemStyle: { color: '#52c41a', borderRadius: [4, 4, 0, 0] },
          label: {
            show: true,
            position: 'top',
            formatter: typeAllOrgTotalLabelFormatter('oneToN'),
            fontSize: 14,
            fontWeight: 600,
            color: '#333'
          }
        }
      ]
    }
  } else {
    typeLegendSelected.value = { 班课: true, '1V1': true, '1对多': true }
    // 柱状图 - 按类型维度，三个系列以便图例显示班课、1V1、1对多
    const classHours = typeData.value.find(item => item.typeName === '班课')?.hours ?? 0
    const oneToOneHours = typeData.value.find(item => item.typeName === '1V1')?.hours ?? 0
    const oneToNHours = typeData.value.find(item => item.typeName === '1对多')?.hours ?? 0

    option = {
      tooltip: {
        trigger: 'item',
        renderMode: 'html',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderColor: '#e8e8e8',
        borderWidth: 1,
        textStyle: chartTooltipTextStyle,
        extraCssText: chartTooltipExtraCssText,
        formatter: itemTooltipFormatterLeft
      },
      legend: {
        data: ['班课', '1V1', '1对多'],
        bottom: 5,
        itemWidth: 14,
        itemHeight: 14,
        textStyle: { fontSize: 12, color: '#666' },
        itemGap: 20
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '14%',
        top: '12%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: ['班课', '1V1', '1对多'],
        axisLabel: { fontSize: 13, color: '#666' },
        axisLine: { lineStyle: { color: '#e8e8e8' } },
        axisTick: { show: false }
      },
      yAxis: {
        type: 'value',
        name: '',
        nameTextStyle: { color: '#999', fontSize: 11 },
        axisLabel: { fontSize: 11, color: '#999' },
        axisLine: { show: false },
        splitLine: { lineStyle: { color: '#f0f0f0', type: 'dashed' } }
      },
      series: [
        {
          name: '班课',
          type: 'bar',
          barWidth: getBarWidth(),
          barMaxWidth: CHART_BAR_MAX_WIDTH,
          barGap: '-100%',
          data: [classHours, 0, 0],
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: '#5a9fff' }, { offset: 1, color: '#3478f6' }]),
            borderRadius: [6, 6, 0, 0]
          },
          label: { show: true, position: 'top', formatter: (params) => params.value ? params.value : '', fontSize: 14, fontWeight: 600, color: '#333' }
        },
        {
          name: '1V1',
          type: 'bar',
          barWidth: getBarWidth(),
          barMaxWidth: CHART_BAR_MAX_WIDTH,
          barGap: '-100%',
          data: [0, oneToOneHours, 0],
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: '#ffbe76' }, { offset: 1, color: '#ff9f43' }]),
            borderRadius: [6, 6, 0, 0]
          },
          label: { show: true, position: 'top', formatter: (params) => params.value ? params.value : '', fontSize: 14, fontWeight: 600, color: '#333' }
        },
        {
          name: '1对多',
          type: 'bar',
          barWidth: getBarWidth(),
          barMaxWidth: CHART_BAR_MAX_WIDTH,
          barGap: '-100%',
          data: [0, 0, oneToNHours],
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: '#73d13d' }, { offset: 1, color: '#52c41a' }]),
            borderRadius: [6, 6, 0, 0]
          },
          label: { show: true, position: 'top', formatter: (params) => params.value ? params.value : '', fontSize: 14, fontWeight: 600, color: '#333' }
        }
      ]
    }
  }

  typeChartInstance.setOption(option, { notMerge: true })
}

// 渲染学部统计图表
const renderDivisionChart = () => {
  if (!divisionChart.value) return

  if (!divisionChartInstance) {
    divisionChartInstance = echarts.init(divisionChart.value)
    divisionChartInstance.on('legendselectchanged', onDivisionLegendSelectChanged)
  }

  let option = {}

  if (isAllOrg.value) {
    // 堆叠图 - 按校区维度
    const divXCount = divisionData.value.length
    const divXRotate =
      divXCount > CHART_X_AXIS_ROTATE_WHEN_COUNT_GT ? CHART_X_AXIS_LABEL_ROTATE : 0
    const divGridBottom = divXRotate ? '16%' : '14%'
    option = {
      tooltip: {
        trigger: 'axis',
        renderMode: 'html',
        axisPointer: { type: 'shadow' },
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderColor: '#e8e8e8',
        borderWidth: 1,
        textStyle: chartTooltipTextStyle,
        extraCssText: chartTooltipExtraCssText,
        formatter: axisTooltipFormatterLeft
      },
      legend: {
        data: ['小学', '初中', '高中'],
        selected: { ...divisionLegendSelected.value },
        bottom: 5,
        itemWidth: 14,
        itemHeight: 14,
        textStyle: { fontSize: 12, color: '#666' },
        itemGap: 15
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: divGridBottom,
        top: '8%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: divisionData.value.map(item => item.orgName),
        axisLabel: {
          fontSize: 12,
          color: '#666',
          rotate: divXRotate,
          interval: 0,
          align: divXRotate ? 'right' : 'center'
        },
        axisLine: { lineStyle: { color: '#e8e8e8' } },
        axisTick: { show: false }
      },
      yAxis: {
        type: 'value',
        name: '',
        nameTextStyle: { color: '#999', fontSize: 11 },
        axisLabel: { fontSize: 11, color: '#999' },
        axisLine: { show: false },
        splitLine: { lineStyle: { color: '#f0f0f0', type: 'dashed' } }
      },
      series: [
        {
          name: '小学',
          type: 'bar',
          stack: 'total',
          barWidth: getBarWidth(),
          barMaxWidth: CHART_BAR_MAX_WIDTH,
          data: divisionData.value.map(item => item.primaryHours),
          itemStyle: { color: '#52c41a', borderRadius: [0, 0, 4, 4] },
          label: {
            show: true,
            position: 'top',
            formatter: divisionAllOrgTotalLabelFormatter('primary'),
            fontSize: 14,
            fontWeight: 600,
            color: '#333'
          }
        },
        {
          name: '初中',
          type: 'bar',
          stack: 'total',
          barWidth: getBarWidth(),
          barMaxWidth: CHART_BAR_MAX_WIDTH,
          data: divisionData.value.map(item => item.juniorHours),
          itemStyle: { color: '#faad14', borderRadius: [0, 0, 0, 0] },
          label: {
            show: true,
            position: 'top',
            formatter: divisionAllOrgTotalLabelFormatter('junior'),
            fontSize: 14,
            fontWeight: 600,
            color: '#333'
          }
        },
        {
          name: '高中',
          type: 'bar',
          stack: 'total',
          barWidth: getBarWidth(),
          barMaxWidth: CHART_BAR_MAX_WIDTH,
          data: divisionData.value.map(item => item.seniorHours),
          itemStyle: { color: '#f5222d', borderRadius: [4, 4, 0, 0] },
          label: {
            show: true,
            position: 'top',
            formatter: divisionAllOrgTotalLabelFormatter('senior'),
            fontSize: 14,
            fontWeight: 600,
            color: '#333'
          }
        }
      ]
    }
  } else {
    divisionLegendSelected.value = { 小学: true, 初中: true, 高中: true }
    // 单校区：x轴为小学、初中、高中，3根独立柱子，图例显示小学/初中/高中
    const primary = divisionData.value[0]?.primaryHours || 0
    const junior = divisionData.value[0]?.juniorHours || 0
    const senior = divisionData.value[0]?.seniorHours || 0
    const xCategories = ['小学', '初中', '高中']

    option = {
      tooltip: {
        trigger: 'item',
        renderMode: 'html',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderColor: '#e8e8e8',
        borderWidth: 1,
        textStyle: chartTooltipTextStyle,
        extraCssText: chartTooltipExtraCssText,
        formatter: itemTooltipFormatterLeft
      },
      legend: {
        data: ['小学', '初中', '高中'],
        bottom: 5,
        itemWidth: 14,
        itemHeight: 14,
        textStyle: { fontSize: 12, color: '#666' },
        itemGap: 20
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '14%',
        top: '12%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: xCategories,
        axisLabel: { fontSize: 13, color: '#666' },
        axisLine: { lineStyle: { color: '#e8e8e8' } },
        axisTick: { show: false }
      },
      yAxis: {
        type: 'value',
        name: '',
        nameTextStyle: { color: '#999', fontSize: 11 },
        axisLabel: { fontSize: 11, color: '#999' },
        axisLine: { show: false },
        splitLine: { lineStyle: { color: '#f0f0f0', type: 'dashed' } }
      },
      series: [
        {
          name: '小学',
          type: 'bar',
          barWidth: getBarWidth(),
          barMaxWidth: CHART_BAR_MAX_WIDTH,
          data: [primary, 0, 0],
          itemStyle: { color: '#52c41a', borderRadius: [6, 6, 0, 0] },
          label: { show: true, position: 'top', formatter: (params) => params.value ? params.value : '', fontSize: 14, fontWeight: 600, color: '#333' }
        },
        {
          name: '初中',
          type: 'bar',
          barWidth: getBarWidth(),
          barMaxWidth: CHART_BAR_MAX_WIDTH,
          barGap: '-100%',
          data: [0, junior, 0],
          itemStyle: { color: '#faad14', borderRadius: [6, 6, 0, 0] },
          label: { show: true, position: 'top', formatter: (params) => params.value ? params.value : '', fontSize: 14, fontWeight: 600, color: '#333' }
        },
        {
          name: '高中',
          type: 'bar',
          barWidth: getBarWidth(),
          barMaxWidth: CHART_BAR_MAX_WIDTH,
          barGap: '-100%',
          data: [0, 0, senior],
          itemStyle: { color: '#f5222d', borderRadius: [6, 6, 0, 0] },
          label: { show: true, position: 'top', formatter: (params) => params.value ? params.value : '', fontSize: 14, fontWeight: 600, color: '#333' }
        }
      ]
    }
  }

  divisionChartInstance.setOption(option, { notMerge: true })
}

// 渲染年级出勤统计图表
const renderGradeChart = () => {
  if (!gradeChart.value) return

  if (!gradeChartInstance) {
    gradeChartInstance = echarts.init(gradeChart.value)
    gradeChartInstance.on('legendselectchanged', onGradeLegendSelectChanged)
  }

  let option = {}
  const dim = selectedGradeDimension.value
  const isRate = dim === 'attendanceRate'

  if (isAllOrg.value) {
    // 全校区：按校区分组堆叠图，X轴为校区
    const allOrgData = gradeData.value
    if (!allOrgData || allOrgData.length === 0) {
      gradeChartInstance.clear()
      return
    }

    // 获取所有出现的年级名称作为图例
    const allGradeNames = []
    allOrgData.forEach((org) => {
      const grades = org.grades || []
      grades.forEach((g) => {
        const key = g.gradeName || g.grade || '未知'
        if (!allGradeNames.includes(key)) allGradeNames.push(key)
      })
    })

    // 初始化选中状态
    if (Object.keys(gradeLegendSelected.value).length === 0) {
      gradeLegendSelected.value = {}
      allGradeNames.forEach((name) => {
        gradeLegendSelected.value[name] = true
      })
    }

    const gradeXCount = allOrgData.length
    const gradeXRotate = gradeXCount > CHART_X_AXIS_ROTATE_WHEN_COUNT_GT ? CHART_X_AXIS_LABEL_ROTATE : 0
    const gradeGridBottom = gradeXRotate ? '16%' : '14%'

    // 构建堆叠数据
    const seriesData = allGradeNames.map((gradeName, index) => {
      const data = allOrgData.map((org) => {
        const grade = (org.grades || []).find((g) => (g.gradeName || g.grade || '未知') === gradeName)
        return grade ? (Number(grade[dim]) || 0) : 0
      })
      return {
        name: gradeName,
        type: 'bar',
        stack: 'total',
        barWidth: getBarWidth(),
        barMaxWidth: CHART_BAR_MAX_WIDTH,
        data,
        itemStyle: {
          color: getGradeColor(index),
          borderRadius: index === allGradeNames.length - 1 ? [4, 4, 0, 0] : [0, 0, 0, 0]
        },
        label: {
          show: true,
          position: 'top',
          formatter: gradeAllOrgTotalLabelFormatter(gradeName),
          fontSize: 12,
          fontWeight: 600,
          color: '#333'
        }
      }
    })

    option = {
      tooltip: {
        trigger: 'axis',
        renderMode: 'html',
        axisPointer: { type: 'shadow' },
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderColor: '#e8e8e8',
        borderWidth: 1,
        textStyle: chartTooltipTextStyle,
        extraCssText: chartTooltipExtraCssText,
        formatter: (params) => {
          if (!params || !params.length) return ''
          const title = params[0].axisValueLabel || params[0].name || ''
          const rows = params.map((p) => {
            const val = isRate ? `${p.value}%` : p.value
            return `<div style="line-height:22px">${p.marker}<span style="margin:0 6px 0 4px">${p.seriesName}</span><span>${val}</span></div>`
          })
          return `<div><div style="font-weight:600;margin-bottom:6px">${title}</div>${rows.join('')}</div>`
        }
      },
      legend: {
        data: allGradeNames,
        selected: { ...gradeLegendSelected.value },
        bottom: 5,
        itemWidth: 14,
        itemHeight: 14,
        textStyle: { fontSize: 12, color: '#666' },
        itemGap: 10
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: gradeGridBottom,
        top: '8%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: allOrgData.map((item) => item.orgName),
        axisLabel: {
          fontSize: 12,
          color: '#666',
          rotate: gradeXRotate,
          interval: 0,
          align: gradeXRotate ? 'right' : 'center'
        },
        axisLine: { lineStyle: { color: '#e8e8e8' } },
        axisTick: { show: false }
      },
      yAxis: {
        type: 'value',
        name: isRate ? '出勤率(%)' : '',
        nameTextStyle: { color: '#999', fontSize: 11 },
        axisLabel: {
          fontSize: 11,
          color: '#999',
          formatter: isRate ? (val) => `${val}%` : undefined
        },
        axisLine: { show: false },
        splitLine: { lineStyle: { color: '#f0f0f0', type: 'dashed' } }
      },
      series: seriesData
    }
  } else {
    // 单个校区：按年级的柱状图，X轴为年级
    const orgData = gradeData.value
    if (!orgData || orgData.length === 0) {
      gradeChartInstance.clear()
      return
    }

    const grades = orgData[0]?.grades || []
    if (grades.length === 0) {
      gradeChartInstance.clear()
      return
    }

    const xCategories = grades.map((g) => g.gradeName || g.grade || '未知')
    const values = grades.map((g) => Number(g[dim]) || 0)

    option = {
      tooltip: {
        trigger: 'item',
        renderMode: 'html',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderColor: '#e8e8e8',
        borderWidth: 1,
        textStyle: chartTooltipTextStyle,
        extraCssText: chartTooltipExtraCssText,
        formatter: (params) => {
          const val = isRate ? `${params.value}%` : params.value
          return `<div style="line-height:22px">${params.marker}<span style="margin:0 6px 0 4px">${params.name}</span><span>${val}</span></div>`
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '14%',
        top: '12%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: xCategories,
        axisLabel: { fontSize: 13, color: '#666' },
        axisLine: { lineStyle: { color: '#e8e8e8' } },
        axisTick: { show: false }
      },
      yAxis: {
        type: 'value',
        name: isRate ? '出勤率(%)' : '',
        nameTextStyle: { color: '#999', fontSize: 11 },
        axisLabel: {
          fontSize: 11,
          color: '#999',
          formatter: isRate ? (val) => `${val}%` : undefined
        },
        axisLine: { show: false },
        splitLine: { lineStyle: { color: '#f0f0f0', type: 'dashed' } }
      },
      series: [
        {
          name: '年级出勤',
          type: 'bar',
          barWidth: getBarWidth(),
          barMaxWidth: CHART_BAR_MAX_WIDTH,
          data: values,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#5a9fff' },
              { offset: 1, color: '#3478f6' }
            ]),
            borderRadius: [6, 6, 0, 0]
          },
          label: {
            show: true,
            position: 'top',
            formatter: (params) => {
              const val = isRate ? `${params.value}%` : params.value
              return params.value ? val : ''
            },
            fontSize: 14,
            fontWeight: 600,
            color: '#333'
          }
        }
      ]
    }
  }

  gradeChartInstance.setOption(option, { notMerge: true })
}

// 年级图表颜色
const gradeColors = ['#3478f6', '#ff9f43', '#52c41a', '#faad14', '#f5222d', '#722ed1', '#13c2c2', '#fa8c16']
const getGradeColor = (index) => gradeColors[index % gradeColors.length]

// 渲染所有图表
const renderCharts = () => {
  renderTypeChart()
  renderDivisionChart()
  flushChartResize()
}

// 窗口大小变化时重新渲染图表
const handleResize = () => {
  const prevPc = isPC.value
  isPC.value =
    typeof window !== 'undefined' && window.innerWidth >= PC_CHART_MIN_WIDTH
  // 跨越 PC/移动断点时柱宽配置会变，需重算 option；同时必须在布局稳定后 resize，否则画布仍沿用旧尺寸
  if (prevPc !== isPC.value) {
    showOrgPcDropdown.value = false
    showOrgPicker.value = false
    showPcRangePicker.value = false
    renderCharts()
  } else {
    flushChartResize()
  }
}

// 获取当前选中的校区ID
const getOrgId = () => {
  console.log('seleselectedOrg>>>>>>>>>',selectedOrg.value)
  return selectedOrg.value === 'all' ? '' : selectedOrg.value
}

// 加载课时概览数据
const loadOverviewData = async () => {
  const orgId = getOrgId()
  const startDate = currentDateRange.value[0]
  const endDate = currentDateRange.value[1]

  try {
    const res = await postStatisticsCourseOverview({ orgId, startDate, endDate })
    console.log('课时概览数据返回:', res)

    if (res.code === '00' && res.data) {
      const data = res.data
      overviewData.value = {
        studentClassHours: data.studentClassHours || 0,
        teacherClassHours: data.teacherClassHours || 0,
        lessonCount: data.lessonCount || 0,
        attendanceCount: data.attendanceCount || 0,
        totalConsumedAmount: data.totalConsumedAmount || 0
      }
    } else {
      console.warn('课时概览接口返回数据格式异常:', res)
      overviewData.value = {
        studentClassHours: 0,
        studentClassHours: 0,
        lessonCount: 0,
        attendanceCount: 0,
        totalConsumedAmount: 0
      }
    }
  } catch (error) {
    console.error('加载课时概览数据失败:', error)
    overviewData.value = {
        studentClassHours: 0,
        studentClassHours: 0,
        lessonCount: 0,
        attendanceCount: 0,
        totalConsumedAmount: 0
      }
  }
}

// 加载图表数据
const loadChartData = async () => {
  const orgId = getOrgId()
  const startDate = currentDateRange.value[0]
  const endDate = currentDateRange.value[1]
  const params = { orgId, startDate, endDate }

  try {
    const [typeRes, periodRes, classRes, teacherRes, classTeacherRes, gradeRes, personalRes] = await Promise.all([
      postHourTypeStatistics(params),
      postHourPeriodStatistics(params),
      postHourClassStatistics(params),
      postHourTeacherRanking(params),
      postHourClassTeacherStatistics(params),
      postHourGradeStatistics(params),
      postHourPersonalStatistics(params)
    ])

    console.log('类型统计:', typeRes)
    console.log('学部统计:', periodRes)
    console.log('班级课时列表:', classRes)
    console.log('老师课时列表:', teacherRes)
    console.log('班主任课时列表:', classTeacherRes)
    console.log('年级课时列表:', gradeRes)
    console.log('个性化课时列表:', personalRes)

    // 类型统计
    const typeStats = (typeRes.code === '00' && typeRes.data) ? typeRes.data : []
    // 学部分统计
    const periodStats = (periodRes.code === '00' && periodRes.data) ? periodRes.data : []
    // 班级课时列表
    classList.value = (classRes.code === '00' && classRes.data) ? classRes.data : []
    // 老师课时列表
    teacherList.value = (teacherRes.code === '00' && teacherRes.data) ? teacherRes.data : []
    // 班主任课时列表
    classTeacherList.value = (classTeacherRes.code === '00' && classTeacherRes.data) ? classTeacherRes.data : []
    // 年级课时列表
    const gradeStats = (gradeRes.code === '00' && gradeRes.data) ? gradeRes.data : []
    // 个性化课时列表
    personalList.value = (personalRes.code === '00' && personalRes.data) ? personalRes.data.map(item => ({
      ...item,
      studentClassHours: item.studentHours || 0,
      teacherClassHours: item.teacherHours || 0
    })) : []

    // 保存原始 API 数据，用于维度切换
    rawTypeStats = typeStats
    rawPeriodStats = periodStats
    rawGradeStats = gradeStats
    rawOrgId = orgId

    // 处理年级课时统计数据
    if (isAllOrg.value) {
      gradeData.value = gradeStats
      gradeListData.value = gradeStats
    } else {
      gradeData.value = gradeStats
      gradeListData.value = gradeStats
    }

    if (isAllOrg.value) {
      // 所有校区 - 按校区维度的堆叠图
      const classField = getClassField(selectedDimension.value)
      const oneToOneField = getOneToOneField(selectedDimension.value)
      const oneToNField = selectedDimension.value === 'oneToN' ? 'oneToNStudentHours' : getOneToNField(selectedDimension.value)
      typeData.value = typeStats.map(item => ({
        orgName: item.orgName || '未知校区',
        classHours: item[classField] || 0,
        oneToOneHours: item[oneToOneField] || 0,
        oneToNHours: item[oneToNField] || 0
      }))

      // 学部分统计：按校区分组汇总各学段课时
      const orgPeriodMap = {}
      const dim = selectedDivisionDimension.value
      periodStats.forEach(item => {
        if (!orgPeriodMap[item.orgId]) {
          orgPeriodMap[item.orgId] = {
            orgName: item.orgName,
            primaryHours: 0,
            juniorHours: 0,
            seniorHours: 0
          }
        }
        let primaryVal = 0, juniorVal = 0, seniorVal = 0
        if (dim === 'attendanceCount') {
          primaryVal = item.attendanceCount || 0
        } else if (dim === 'lessonCount') {
          primaryVal = item.lessonCount || 0
        } else if (dim === 'teacherHours') {
          primaryVal = item.teacherHours || 0
        } else if (dim === 'studentAmount') {
          primaryVal = item.studentAmount || 0
        } else {
          primaryVal = item.studentHours || 0
        }
        juniorVal = primaryVal
        seniorVal = primaryVal

        if (item.period === '1') {
          orgPeriodMap[item.orgId].primaryHours += primaryVal
        } else if (item.period === '2') {
          orgPeriodMap[item.orgId].juniorHours += juniorVal
        } else if (item.period === '3') {
          orgPeriodMap[item.orgId].seniorHours += seniorVal
        }
      })
      divisionData.value = Object.values(orgPeriodMap)

    } else {
      // 单个校区 - 按类型/学段的柱状图
      const currentOrgTypeStats = typeStats.filter(item => String(item.orgId) === String(orgId))
      const currentOrgPeriodStats = periodStats.filter(item => String(item.orgId) === String(orgId))

      const classField = getClassField(selectedDimension.value)
      const oneToOneField = getOneToOneField(selectedDimension.value)
      const oneToNField = selectedDimension.value === 'oneToN' ? 'oneToNStudentHours' : getOneToNField(selectedDimension.value)
      const classHours = currentOrgTypeStats.reduce((sum, item) => sum + (item[classField] || 0), 0)
      const oneToOneHoursVal = currentOrgTypeStats.reduce((sum, item) => sum + (item[oneToOneField] || 0), 0)
      const oneToNHoursVal = currentOrgTypeStats.reduce((sum, item) => sum + (item[oneToNField] || 0), 0)
      typeData.value = [
        { typeName: '班课', hours: Math.round(classHours) },
        { typeName: '1V1', hours: Math.round(oneToOneHoursVal) },
        { typeName: '1对多', hours: Math.round(oneToNHoursVal) }
      ]

      // 学部分统计：按学段维度，保持与所有校区相同的结构
      const dim = selectedDivisionDimension.value
      let primaryHours = 0
      let juniorHours = 0
      let seniorHours = 0
      currentOrgPeriodStats.forEach(item => {
        if (dim === 'attendanceCount') {
          if (item.period === '1') primaryHours += item.attendanceCount || 0
          else if (item.period === '2') juniorHours += item.attendanceCount || 0
          else if (item.period === '3') seniorHours += item.attendanceCount || 0
        } else if (dim === 'lessonCount') {
          if (item.period === '1') primaryHours += item.lessonCount || 0
          else if (item.period === '2') juniorHours += item.lessonCount || 0
          else if (item.period === '3') seniorHours += item.lessonCount || 0
        } else if (dim === 'teacherHours') {
          if (item.period === '1') primaryHours += item.teacherHours || 0
          else if (item.period === '2') juniorHours += item.teacherHours || 0
          else if (item.period === '3') seniorHours += item.teacherHours || 0
        } else if (dim === 'studentAmount') {
          if (item.period === '1') primaryHours += item.studentAmount || 0
          else if (item.period === '2') juniorHours += item.studentAmount || 0
          else if (item.period === '3') seniorHours += item.studentAmount || 0
        } else {
          // studentHours
          if (item.period === '1') primaryHours += item.studentHours || 0
          else if (item.period === '2') juniorHours += item.studentHours || 0
          else if (item.period === '3') seniorHours += item.studentHours || 0
        }
      })
      // 单校区只有一个数据项，但保持结构一致用于图表
      divisionData.value = [{
        orgName: '学部分布',
        primaryHours: Math.round(primaryHours),
        juniorHours: Math.round(juniorHours),
        seniorHours: Math.round(seniorHours)
      }]
    }

    renderCharts()
  } catch (error) {
    console.error('加载课时图表数据失败:', error)
    typeData.value = []
    divisionData.value = []
    classList.value = []
    teacherList.value = []
    classTeacherList.value = []
    personalList.value = []
    renderCharts()
  }
}

// 刷新数据
const handleRefresh = async () => {
  if (refreshing.value) return
  refreshing.value = true
  try {
    await loadData()
  } finally {
    refreshing.value = false
  }
}

// 统一加载数据
const loadData = async () => {
  loadOverviewData()
  loadChartData()
}

const handlePcQuickDate = (key) => {
  currentQuickType.value = key
  currentDateRange.value = getDateRangeByType(key)
  saveDateSelection()
  loadData()
}

function readPcRangeAnchorFromDom() {
  const el = pcDateRangeInputRef.value
  if (!el?.getBoundingClientRect) {
    pcRangeAnchorRect.value = null
    return
  }
  const r = el.getBoundingClientRect()
  pcRangeAnchorRect.value = {
    top: r.top,
    left: r.left,
    bottom: r.bottom,
    right: r.right,
    width: r.width,
    height: r.height,
  }
}

let pcAnchorScrollCleanup = null

const openPcRangePicker = () => {
  readPcRangeAnchorFromDom()
  showPcRangePicker.value = true
}

watch(showPcRangePicker, (open) => {
  if (pcAnchorScrollCleanup) {
    pcAnchorScrollCleanup()
    pcAnchorScrollCleanup = null
  }
  if (!open) return
  readPcRangeAnchorFromDom()
  const onScrollOrResize = () => readPcRangeAnchorFromDom()
  window.addEventListener('scroll', onScrollOrResize, true)
  window.addEventListener('resize', onScrollOrResize)
  pcAnchorScrollCleanup = () => {
    window.removeEventListener('scroll', onScrollOrResize, true)
    window.removeEventListener('resize', onScrollOrResize)
  }
})

const onPcRangeConfirm = (range) => {
  currentQuickType.value = QUICK_KEY.custom
  currentDateRange.value = range
  try {
    localStorage.setItem('customData', range.join(','))
  } catch (e) {
    /* ignore */
  }
  saveDateSelection()
  loadData()
}

// 导出班级课时列表
const handleExportClass = () => {
  const orgId = getOrgId()
  const startDate = currentDateRange.value?.[0] || ''
  const endDate = currentDateRange.value?.[1] || ''
  const type = 'class'

  // 向父级iframe发送导出参数请求
  if (window.parent !== window) {
    window.parent.postMessage(
      {
        type: 'exportParams',
        exportType: type,
        orgId,
        startDate,
        endDate
      },
      '*'
    )
  }
}

// 导出老师课时列表
const handleExportTeacher = () => {
  const orgId = getOrgId()
  const startDate = currentDateRange.value?.[0] || ''
  const endDate = currentDateRange.value?.[1] || ''
  const type = 'teacher'

  // 向父级iframe发送导出参数请求
  if (window.parent !== window) {
    window.parent.postMessage(
      {
        type: 'exportParams',
        exportType: type,
        orgId,
        startDate,
        endDate
      },
      '*'
    )
  }
}

// 导出个性化课时列表
const handleExportPersonal = () => {
  const orgId = getOrgId()
  const startDate = currentDateRange.value?.[0] || ''
  const endDate = currentDateRange.value?.[1] || ''
  const type = 'personal'

  // 向父级iframe发送导出参数请求
  if (window.parent !== window) {
    window.parent.postMessage(
      {
        type: 'exportParams',
        exportType: type,
        orgId,
        startDate,
        endDate
      },
      '*'
    )
  }
}

// 跳转到个性化课时详情
const goToPersonalDetail = () => {
  saveOrgSelection()
  saveDateSelection()
  const orgId = getOrgId()
  const startDate = currentDateRange.value[0]
  const endDate = currentDateRange.value[1]
  router.push({
    name: 'HoursDetail',
    query: {
      type: 'personal',
      orgId,
      startDate,
      endDate,
      orgName: selectedOrgName.value
    }
  })
}

// iframe消息处理：接收web端导出参数请求
const handleIframeMessage = (event) => {
  const { data } = event
  if (data && data.type === 'exportParams') {
    // 获取当前选中的机构ID和时间范围
    const orgId = getOrgId() // 使用现有的getOrgId方法
    const startDate = currentDateRange.value?.[0] || ''
    const endDate = currentDateRange.value?.[1] || ''

    // 向web端返回参数
    if (event.source && event.source.postMessage) {
      event.source.postMessage(
        {
          type: 'exportParams',
          orgId,
          startDate,
          endDate
        },
        '*'
      )
    }
  }
}

onMounted(async () => {
  console.log('route?.query>>>>>>', route?.query)
  if(route?.query?.token) {
      localStorage.setItem('token', route?.query?.token)
  }

  if(route?.query?.selctedOrgName) {
    // selectedOrgName.value = route?.query?.selctedOrgName
  }

  if(route?.query?.selctedOrgId) {
    selectedOrg.value = route?.query?.selctedOrgId
    sessionStorage.setItem(ORG_CACHE_KEY, selectedOrg.value)
  }

  console.log('selctedOrgId.value====>', selectedOrg.value)

  // userType 用户角色
  userType.value = ''
  if(route?.query?.userType) {
      localStorage.setItem('userType', route?.query?.userType)
      userType.value = route?.query?.userType
  }
  source.value = route?.query?.source || '';
  getUserInfo()
  await loadOrgList()
  loadData()
  document.addEventListener('click', onDocumentClickCloseOrgPc)
  window.addEventListener('resize', handleResize)
  // 添加iframe消息监听
  window.addEventListener('message', handleIframeMessage)
  await nextTick()
  chartResizeObserver = new ResizeObserver(() => flushChartResize())
  if (typeChart.value) chartResizeObserver.observe(typeChart.value)
  if (divisionChart.value) chartResizeObserver.observe(divisionChart.value)
})

// 组件卸载前保存校区选择和时间筛选
onBeforeUnmount(() => {
  sessionStorage.setItem(ORG_CACHE_KEY, selectedOrg.value)
  saveDateSelection()
  window.removeEventListener('message', handleIframeMessage)
})

onUnmounted(() => {
  pcAnchorScrollCleanup?.()
  document.removeEventListener('click', onDocumentClickCloseOrgPc)
  window.removeEventListener('resize', handleResize)
  chartResizeObserver?.disconnect()
  chartResizeObserver = null
  typeChartInstance?.dispose()
  divisionChartInstance?.dispose()
})
</script>

<style lang="scss" scoped>
.course-statistics-page {
  background: linear-gradient(180deg, #e8f4ff 0%, #f5f6fa 30%);
  min-height: 100vh;
  padding-bottom: 20px;
  height: 100vh;
  overflow-y: scroll;
}

.header-section-pc {
  padding: 16px 16px 12px;
  background: transparent;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .org-select-row-pc {
    display: flex;
    align-items: center;
    max-width: 1200px;
  }

  .header-actions-pc {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-right: 12px;
  }

  .refresh-btn-pc {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 4px;
    height: 28px;
    margin-bottom: 8px;

    .is-spinning {
      animation: spin 0.8s linear infinite;
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .org-select-wrap {
    position: relative;
    width: 100%;
    max-width: 200px;
    min-width: 200px;
  }

  .org-select-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    min-height: 32px;
    padding: 0 14px;
    cursor: pointer;
    outline: none;

    &:hover {
      border-color: #91b5d9;
      box-shadow: 0 1px 3px rgba(15, 37, 64, 0.06);
    }

    &.is-open {
      border-color: #3478f6;
      box-shadow: 0 0 0 2px rgba(52, 120, 246, 0.12);
    }

    &:focus-visible {
      border-color: #3478f6;
      box-shadow: 0 0 0 2px rgba(52, 120, 246, 0.12);
    }
  }

  .org-select-trigger-text {
    flex: 1;
    min-width: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.88);
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .org-select-chevron {
    flex-shrink: 0;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.28);
  }

  .org-select-dropdown {
    position: absolute;
    left: 0;
    right: 0;
    top: calc(100% + 12px);
    z-index: 200;
    background: #fff;
    border: 1px solid #e4eaf2;
    border-radius: 6px;
    box-shadow:
      0 4px 14px rgba(15, 37, 64, 0.1),
      0 0 1px rgba(15, 37, 64, 0.06);
    max-height: 300px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .org-select-list {
    margin: 0;
    padding: 6px 0;
    list-style: none;
  }

  .org-select-item {
    padding: 10px 14px;
    font-size: 14px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.88);
    text-align: left;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;

    &:hover {
      background: #f5f8fc;
    }

    &.active {
      color: #3478f6;
      font-weight: 500;
      background: rgba(52, 120, 246, 0.08);
    }
  }
}

.header-section {
  background: linear-gradient(135deg, #3478f6 0%, #5a9fff 100%);
  padding: 8px 16px 24px;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 16px rgba(52, 120, 246, 0.2);

  .h5-header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .h5-header-right {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .refresh-btn-h5 {
    background: rgba(255, 255, 255, 0.25);
    border: 1px solid rgba(255, 255, 255, 0.4);
    color: #fff;
    min-width: 36px;
    padding: 0 8px;

    &:active {
      background: rgba(255, 255, 255, 0.35);
    }

    .van-icon {
      font-size: 16px;

      &.is-spinning {
        animation: spin 0.8s linear infinite;
      }
    }
  }

  .org-select-card {
    display: flex;
    align-items: center;
    flex: 1;
  }

  .org-select-btn {
    color: #fff;
    font-size: 17px;
    font-weight: 600;
    padding: 0 12px;
    height: 40px;
    display: flex;
    align-items: center;
    cursor: pointer;
    background: transparent;
  }

  .date-filter-btn-mobile {
    display: flex;
    align-items: center;
    gap: 4px;
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.4);
    color: #fff;
    font-size: 13px;
    border-radius: 16px;
    padding: 6px 12px;
    backdrop-filter: blur(4px);

    &:active {
      background: rgba(255, 255, 255, 0.3);
    }

    :deep(.van-icon) {
      color: #fff;
    }
  }
}

.overview-section {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(52, 120, 246, 0.08);
  margin: -22px 10px 12px 10px;
  padding: 10px 10px 8px;
  position: relative;
  z-index: 10;
}

.overview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.pc-date-filter-bar-standalone {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 12px 24px;

  .pc-date-quick-tabs {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px 16px;
  }

  .pc-date-tab {
    position: relative;
    padding: 4px 6px 12px;
    border: none;
    background: transparent;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.72);
    cursor: pointer;
    line-height: 22px;
    transition: color 0.2s;

    &:hover {
      color: #3478f6;
    }

    &.active {
      color: #3478f6;
      font-weight: 600;

      &::after {
        content: '';
        position: absolute;
        left: 6px;
        right: 6px;
        bottom: 4px;
        height: 3px;
        background: #3478f6;
        border-radius: 2px 2px 0 0;
      }
    }
  }

  .pc-date-range-input {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 268px;
    max-width: 340px;
    height: 28px;
    padding: 0 14px;
    background: #fff;
    border: 1px solid #d9e2ec;
    border-radius: 4px;
    box-shadow: 0 1px 2px rgba(15, 37, 64, 0.04);
    cursor: pointer;
    transition: border-color 0.2s, box-shadow 0.2s;
    margin-bottom: 8px;

    &:hover {
      border-color: #91b5d9;
    }

    &.is-custom {
      border-color: #3478f6;
      box-shadow: 0 0 0 2px rgba(52, 120, 246, 0.12);
    }

    .pc-date-range-input__icon {
      flex-shrink: 0;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.28);
    }

    .pc-date-range-input__inner {
      flex: 1;
      min-width: 0;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
      font-size: 14px;
    }

    .pc-date-range-input__part {
      color: rgba(0, 0, 0, 0.88);

      &.is-ph {
        color: rgba(0, 0, 0, 0.32);
      }
    }

    .pc-date-range-input__sep {
      color: rgba(0, 0, 0, 0.45);
      flex-shrink: 0;
    }
  }
}

.section-title {
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
  display: flex;
  align-items: center;
  gap: 8px;

  .title-icon {
    width: 4px;
    height: 16px;
    background: linear-gradient(180deg, #3478f6 0%, #5a9fff 100%);
    border-radius: 2px;

    &.type {
      background: linear-gradient(180deg, #ff9f43 0%, #ffbe76 100%);
    }

    &.division {
      background: linear-gradient(180deg, #52c41a 0%, #95de64 100%);
    }

    &.grade-icon {
      background: linear-gradient(180deg, #722ed1 0%, #b37feb 100%);
    }
  }
}

.month-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #f0f5ff;
  border: 1px solid #d9e4ff;
  color: #3478f6;
  font-size: 13px;
  border-radius: 16px;
  padding: 4px 12px;

  &:active {
    background: #e6f0ff;
  }
}

.overview-cards-wrap {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 2px;
  margin: 0 -1px;
  padding-left: 1px;
  padding-right: 1px;
  scrollbar-width: thin;
}

.overview-cards-wrap::-webkit-scrollbar {
  height: 4px;
}

.overview-cards-wrap::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.overview-cards {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  width: max-content;
  min-width: 100%;
  box-sizing: border-box;
}

.overview-card {
  flex: 0 0 auto;
  min-width: 3.5rem;
  max-width: none;
  background: linear-gradient(135deg, #f8faff 0%, #fff 100%);
  border-radius: 10px;
  padding: 10px 8px;
  text-align: center;
  border: 1px solid #e8eef5;
  transition: all 0.3s ease;

  &:active {
    transform: scale(0.98);
  }

  .card-icon {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 10px;
  }

  &.total .card-icon {
    background: linear-gradient(135deg, #e0efff 0%, #cce4ff 100%);
    color: #3478f6;
  }

  &.class-course .card-icon {
    background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
    color: #ff9f43;
  }

  &.one-to-one .card-icon {
    background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
    color: #52c41a;
  }

  .card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
  }

  .card-label {
    font-size: 11px;
    color: #8c8c8c;
    margin: 0;
    white-space: nowrap;
    line-height: 1.2;
  }

  .card-value {
    font-size: 18px;
    font-weight: 700;
    white-space: nowrap;
    line-height: 1.2;
    background: linear-gradient(135deg, #3478f6 0%, #5a9fff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  &.class-course .card-value {
    background: linear-gradient(135deg, #ff9f43 0%, #ffbe76 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  &.one-to-one .card-value {
    background: linear-gradient(135deg, #52c41a 0%, #95de64 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  &.attendance .card-icon {
    background: linear-gradient(135deg, #f5f5f5 0%, #d9d9d9 100%);
    color: #8c8c8c;
  }

  &.attendance .card-value {
    background: linear-gradient(135deg, #969696 0%, #4d4d4d 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
}

.chart-section {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(52, 120, 246, 0.08);
  margin: 0 10px 12px 10px;
  padding: 12px;
}

.dimension-toggle {
  display: flex;
  gap: 8px;
  margin: 12px 0;
}

.toggle-btn {
  flex: 1;
  padding: 4px 0;
  text-align: center;
  font-size: 12px;
  color: #999;
  background: #f7f8fa;
  border-radius: 8px;
  border: 1px solid transparent;
  transition: all 0.25s ease;
  max-width: 80px;

  &.active {
    color: #4b85ef;
    background: #e8f4ff;
    border-color: #b3d4ff;
    font-weight: 500;
  }

  &:active {
    transform: scale(0.98);
  }
}

.bar-chart {
  width: 100%;
  height: 240px;
}

// 列表样式
.list-section {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(52, 120, 246, 0.08);
  margin: 0 10px 12px 10px;
  padding: 12px;
}

.section-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.section-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-wrap {
  position: relative;
  display: flex;
  align-items: center;
  background: #f5f7fa;
  border: 1px solid #e8eef5;
  border-radius: 20px;
  padding: 0 10px;
  height: 30px;
  min-width: 100px;
  transition: all 0.2s;

  &:focus-within {
    border-color: #3478f6;
    background: #fff;
    box-shadow: 0 0 0 2px rgba(52, 120, 246, 0.1);
  }

  .search-icon {
    font-size: 14px;
    color: #999;
    flex-shrink: 0;
  }

  .search-input {
    flex: 1;
    border: none;
    background: transparent;
    outline: none;
    font-size: 13px;
    color: #333;
    padding: 0 8px;
    width: 80px;

    &::placeholder {
      color: #999;
    }
  }

  .clear-icon {
    font-size: 14px;
    color: #999;
    cursor: pointer;
    flex-shrink: 0;

    &:active {
      color: #666;
    }
  }
}

.export-btn {
  padding: 0 12px;
  height: 28px;
  font-size: 12px;
  border-color: #ee0a24;
  color: #ee0a24;
  background: transparent;
  margin-right: 16px;

  &:active {
    background: #e8f4ff;
  }
}

.more-btn {
  display: flex;
  align-items: center;
  gap: 2px;
  color: #3478f6;
  font-size: 13px;
  cursor: pointer;

  &:active {
    opacity: 0.7;
  }
}

.title-icon.class-icon {
  background: linear-gradient(180deg, #722ed1 0%, #b37feb 100%);
}

.title-icon.teacher-icon {
  background: linear-gradient(180deg, #13c2c2 0%, #36cfc9 100%);
}

.title-icon.head-icon {
  background: linear-gradient(180deg, #fa8c16 0%, #fdba74 100%);
}

.title-icon.personal-icon {
  background: linear-gradient(180deg, #eb2f96 0%, #f691d3 100%);
}

.list-content {
  margin-top: 16px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  .list-item {
    min-width: 700px;
  }
}

.list-item {
  display: flex;
  align-items: center;
  padding: 14px 12px;
  border-radius: 8px;
  font-size: 14px;

  &.header {
    background: #f5f7fa;
    color: #666;
    font-weight: 600;
    font-size: 13px;
    padding: 12px;
  }

  &.odd {
    background: #fafafa;
  }

  &.top3 {
    .col-value {
      color: #ff6b6b;
      font-weight: 600;
    }
  }
}

.col-rank {
  width: 50px;
  flex-shrink: 0;
}

.col-name {
  flex: 1;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &.clickable {
    color: #3478f6;
    cursor: pointer;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
}

/* 班级课时列表：所有列均匀分布 */
.list-content--class-hours {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  .list-item--class-hours {
    align-items: flex-start;
    // min-width: 100%;
    display: flex;
    flex-wrap: nowrap;
  }

  .col-class-name,
  .col-class-code,
  .col-grade-name,
  .col-personal-period,
  .col-hours-compact {
    flex: 1 1 0;
    min-width: 0;
    padding: 8px 4px;
    color: #333;
    text-align: center;
    word-break: break-word;
  }

  .col-class-name {
    text-align: left;
    flex: 1.2 1 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-width: 80px
  }

  .col-personal-period {
    text-align: left;
    flex: 1.2 1 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-width: 100px
  }

  .col-class-code {
    text-align: left;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-width: 80px
  }

  .col-grade-name {
    text-align: left;
    flex: 0.8 1 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-width: 60px
  }

  .col-hours-compact {
    flex-shrink: 0;
    white-space: nowrap;
    min-width: 50px;

    &.highlight {
      color: #3478f6;
      font-weight: 600;
    }
  }
}

.col-value {
  width: 80px;
  text-align: right;
  color: #666;
  flex-shrink: 0;

  &.highlight {
    color: #3478f6;
    font-weight: 600;
    font-size: 15px;
  }
}

.rank-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 600;
  background: #e8e8e8;
  color: #666;

  &.rank-1 {
    background: linear-gradient(135deg, #ffd700 0%, #ffb700 100%);
    color: #fff;
  }

  &.rank-2 {
    background: linear-gradient(135deg, #c0c0c0 0%, #a8a8a8 100%);
    color: #fff;
  }

  &.rank-3 {
    background: linear-gradient(135deg, #cd7f32 0%, #b5651d 100%);
    color: #fff;
  }
}

</style>
